// extracted by mini-css-extract-plugin
export default {"container":"UN-z","topReviewHeading":"VN-z","criticalReview":"WN-z","favorableReview":"XN-z","vsSeparator":"YN-z"};